import { PayerRiskAdjustmentPolicyUpdate } from "./payer-config-item";

export class AddUpdatePayerRiskAdjustmentPoliciesRequest {
    RiskPolicies: PayerRiskAdjustmentPolicyUpdate[] = [];
    PayerName?: string;
}
